/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const userDefaultSettingSchema = z.object({
  appId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  env: z.string().nullish(),
  id: z.string().uuid(),
  name: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  value: z.string().nullish(),
});

export type UserDefaultSetting = z.infer<typeof userDefaultSettingSchema>;
